export default {
    view: "Mehr sehen"
}